import _ from 'lodash';
import { log } from '@jutro/logger';
const defaultErrorCategory = {};
let errorCategories;
let errorCategoryKnockoutPaths;
function getErrorCategoryKnockoutPath(errorCategory, knockoutPaths) {
  const knockoutPath = knockoutPaths[errorCategory];
  if (!knockoutPath) {
    log.warning(`Missing KnockoutPath configuration for error category: ${errorCategory}`);
  }
  return knockoutPath;
}
export function getErrorCategory(errorCode) {
  if (errorCategories && errorCategories[errorCode]) {
    const errorCategory = errorCategories[errorCode];
    const categoryMapping = errorCategory.categoryMapping,
      appErrorCode = errorCategory.appErrorCode;
    const knockoutPath = getErrorCategoryKnockoutPath(categoryMapping, errorCategoryKnockoutPaths);
    return {
      categoryMapping,
      appErrorCode,
      knockoutPath
    };
  }
  return defaultErrorCategory;
}
export function setErrorCategoryKnockoutMaps(appErrorCategories, appKnockoutPaths) {
  if (!_.isObject(appErrorCategories)) {
    throw new TypeError(`Expected an object for 'errorCategories', got a '${typeof appErrorCategories}' instead`);
  }
  errorCategories = appErrorCategories;
  if (!_.isObject(appKnockoutPaths)) {
    throw new TypeError(`Expected an object for 'knockoutPaths', got a '${typeof appKnockoutPaths}' instead`);
  }
  errorCategoryKnockoutPaths = appKnockoutPaths;
}